import { handleRentVsBuyClickstreamEvent, eventTypes, rentVsBuyInteractionTypes } from "../../utils/clickstream/clickStreamEvents.esm.js";
import { RentVsBuyVariables } from "./RentVsBuyCalculator.constants.esm.js";
const getCurrDisplayedFields = (currentState) => ({
  [rentVsBuyInteractionTypes.HOME_PRICE]: currentState.purchasePrice,
  [rentVsBuyInteractionTypes.DOWN_PAYMENT]: currentState.downPaymentPercent,
  [rentVsBuyInteractionTypes.MONTHLY_RENT]: currentState.monthlyRent,
  [rentVsBuyInteractionTypes.HOME_APPRECIATION_RATE]: currentState.initialHomeAppreciationRate,
  [rentVsBuyInteractionTypes.RENT_APPRECIATION_RATE]: currentState.initialRentAppreciationRate,
  [rentVsBuyInteractionTypes.INVESTMENT_RATE]: currentState.investmentReturnRate,
  [rentVsBuyInteractionTypes.MORTGAGE_RATE]: currentState.mortgageRate,
  [rentVsBuyInteractionTypes.HOA_FEES]: currentState.hoaDues,
  [rentVsBuyInteractionTypes.PROPERTY_TAX_RATE]: currentState.propertyTaxRate,
  [rentVsBuyInteractionTypes.MAINTENANCE_RATE]: currentState.maintenanceCostsPercent,
  [rentVsBuyInteractionTypes.PURCHASE_COSTS_PERCENT]: currentState.purchaseCostsPercent,
  [rentVsBuyInteractionTypes.SELLING_COSTS_PERCENT]: currentState.sellingCostsPercent,
  [rentVsBuyInteractionTypes.HOMEOWNERS_INSURANCE_COST]: currentState.homeownersInsurancePercent,
  [rentVsBuyInteractionTypes.MARGINAL_TAX_RATE]: currentState.marginalTaxRate,
  [rentVsBuyInteractionTypes.ANNUAL_RENOVATION_COSTS]: currentState.renovationCostsPercent,
  [rentVsBuyInteractionTypes.RENTING_UTILITY_COSTS]: currentState.rentingUtilities,
  [rentVsBuyInteractionTypes.RENT_BROKER_FEE]: currentState.rentBrokerFee,
  [rentVsBuyInteractionTypes.RENTERS_INSURANCE_COST]: currentState.rentersInsuranceRate
});
const stateKeyToInteractionType = {
  [RentVsBuyVariables.PurchasePrice]: rentVsBuyInteractionTypes.HOME_PRICE,
  downPaymentPercent: rentVsBuyInteractionTypes.DOWN_PAYMENT,
  monthlyRent: rentVsBuyInteractionTypes.MONTHLY_RENT,
  initialHomeAppreciationRate: rentVsBuyInteractionTypes.HOME_APPRECIATION_RATE,
  initialRentAppreciationRate: rentVsBuyInteractionTypes.RENT_APPRECIATION_RATE,
  investmentReturnRate: rentVsBuyInteractionTypes.INVESTMENT_RATE,
  [RentVsBuyVariables.MortgageRate]: rentVsBuyInteractionTypes.MORTGAGE_RATE,
  hoaDues: rentVsBuyInteractionTypes.HOA_FEES,
  propertyTaxRate: rentVsBuyInteractionTypes.PROPERTY_TAX_RATE,
  maintenanceCostsPercent: rentVsBuyInteractionTypes.MAINTENANCE_RATE,
  purchaseCostsPercent: rentVsBuyInteractionTypes.PURCHASE_COSTS_PERCENT,
  sellingCostsPercent: rentVsBuyInteractionTypes.SELLING_COSTS_PERCENT,
  homeownersInsurancePercent: rentVsBuyInteractionTypes.HOMEOWNERS_INSURANCE_COST,
  [RentVsBuyVariables.MarginalTaxRate]: rentVsBuyInteractionTypes.MARGINAL_TAX_RATE,
  renovationCostsPercent: rentVsBuyInteractionTypes.ANNUAL_RENOVATION_COSTS,
  rentingUtilities: rentVsBuyInteractionTypes.RENTING_UTILITY_COSTS,
  rentBrokerFee: rentVsBuyInteractionTypes.RENT_BROKER_FEE,
  rentersInsuranceRate: rentVsBuyInteractionTypes.RENTERS_INSURANCE_COST,
  interestRate: rentVsBuyInteractionTypes.MORTGAGE_RATE
};
const trackClickstreamInteraction = (stateKey, currentState) => {
  const interactionType = stateKeyToInteractionType[stateKey] ?? rentVsBuyInteractionTypes.HOME_PRICE;
  handleRentVsBuyClickstreamEvent(eventTypes.RENT_VS_BUY_INTERACTION, interactionType, getCurrDisplayedFields(currentState));
};
const trackRentVsBuyView = () => {
  handleRentVsBuyClickstreamEvent(eventTypes.RENT_VS_BUY_VIEW);
};
export {
  trackClickstreamInteraction,
  trackRentVsBuyView
};
